<template>
  <div class="charge-panel" :style="style">
    <svg class="charge-panel__icon" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M59.4159 52.795C59.0403 52.252 58.4979 51.8552 57.872 51.6255V5.36721C57.872 3.94709 57.3088 2.58963 56.3074 1.58719C55.306 0.56387 53.9291 0 52.5104 0H28.9777C27.5591 0 26.2031 0.56387 25.2017 1.56631C24.2003 2.56874 23.637 3.92621 23.637 5.34633V32.1406V36.3592H18.9221C17.879 36.3592 17.0445 37.1946 17.0445 38.2388V45.5064C17.0445 47.2398 16.1892 48.9941 14.2698 48.9941C13.5605 48.9941 12.9138 48.7226 12.4339 48.2214C11.8289 47.5948 11.516 46.6551 11.516 45.4856V21.2391C13.0181 20.5499 13.9152 18.9628 13.9152 17.2503V5.45075C13.9152 4.03063 13.3519 2.67316 12.3505 1.67073C11.3491 0.668291 9.97218 0.10442 8.55355 0.10442H3.2128C2.35744 0.10442 1.54381 0.438566 0.938804 1.0442C0.333797 1.64984 0 2.46432 0 3.32057V7.60181C0 8.45806 0.333797 9.27254 0.938804 9.87818C1.54381 10.4838 2.35744 10.818 3.2128 10.818H5.36161V17.0623C5.36161 18.9836 6.25869 20.5291 7.76078 21.2182V45.5064C7.76078 48.2423 8.84562 49.913 9.7427 50.8528C10.9318 52.0849 12.5382 52.7741 14.2698 52.7741C17.5243 52.7741 20.7997 50.2889 20.7997 45.5273V40.1392H23.6161V51.6464C22.9903 51.8761 22.4478 52.2729 22.0723 52.8159C21.6968 53.3589 21.4882 54.0063 21.4882 54.6537V58.9349C21.4882 59.2273 21.5925 59.4988 21.8011 59.6867C22.0097 59.8747 22.2809 60 22.5522 60H58.936C59.2281 60 59.4993 59.8956 59.6871 59.6867C59.8748 59.4779 60 59.2064 60 58.9349V54.6537C60 53.9854 59.7914 53.338 59.4159 52.795ZM8.42837 7.30943C8.21975 7.10059 7.94854 6.99617 7.67733 6.99617H4.75661V3.50853H7.30181C8.15716 3.50853 8.97079 3.84267 9.5758 4.44831C10.1808 5.05395 10.5146 5.86843 10.5146 6.72468V17.0832C10.5146 17.835 10.1391 18.1483 9.59666 18.1483C9.05424 18.1483 8.74131 17.7932 8.74131 17.0832V8.10303C8.74131 7.78977 8.637 7.51827 8.42837 7.30943ZM27.8512 51.4375V7.45562C27.8512 6.59937 28.185 5.78489 28.79 5.17926C29.395 4.57362 30.2086 4.23947 31.064 4.23947H50.4451C51.3004 4.23947 52.114 4.57362 52.7191 5.17926C53.3241 5.78489 53.6579 6.59937 53.6579 7.45562V51.4375H27.8512Z" :fill="providerColor"/>
      <path d="M46.1057 29.7598C46.064 29.7598 46.0014 29.7807 45.9597 29.7807L40.8067 31.0546L43.039 25.0191C43.0807 24.9356 43.1016 24.873 43.1016 24.7894C43.1016 24.497 42.8512 24.2464 42.5174 24.2464H38.2406C37.9694 24.2464 37.7399 24.4135 37.6774 24.6641L35.0487 35.4403C35.007 35.6283 35.0696 35.8162 35.2156 35.9415C35.3199 36.0251 35.4659 36.0877 35.612 36.0877C35.6537 36.0877 35.7163 36.0877 35.758 36.0668L41.057 34.7511L38.491 45.2976C38.4284 45.5691 38.5953 45.8406 38.8874 45.945C38.95 45.9659 39.0125 45.9659 39.0751 45.9659C39.3046 45.9659 39.5132 45.8406 39.6175 45.6317L46.669 30.5325C46.7525 30.3446 46.7107 30.1149 46.5856 29.9687C46.4187 29.8434 46.2726 29.7598 46.1057 29.7598Z" :fill="providerColor"/>
      <path d="M47.7538 7.18413H33.5883C32.0445 7.18413 30.7719 8.45806 30.7719 10.0035V17.2503C30.7719 18.7957 32.0445 20.0696 33.5883 20.0696H47.7538C49.2976 20.0696 50.5702 18.7957 50.5702 17.2503V10.0035C50.5702 8.45806 49.2976 7.18413 47.7538 7.18413Z" :fill="providerColor"/>
    </svg>
    <div class="charge-panel__text">
      <div class="charge-panel__text__label">{{ $t('evDeviceChargeStatus') }}</div>
      <div class="charge-panel__text__value">{{ evChargingStatus }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChargePanel',
  props: {
    args: {
      type: Object,
      required: true,
    },
    brand: {
      type: Object,
      default: () => ({
        color: '#000000',
      }),
    },
  },
  computed: {
    providerColor() {
      return this.brand.color;
    },
    evChargingStatus() {
      let evChargingStatus = '';

      switch (this.args.evChargingStatus) {
        case 'CHARGING':
          evChargingStatus = this.$i18n.t('charging');
          break;
        case 'NOT_CHARGING':
        default:
          evChargingStatus = this.$i18n.t('notCharging');
          break;
      }

      return evChargingStatus;
    },
    style() {
      return {
        '--provider-color': this.providerColor,
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/mixins.scss';

.charge-panel {
  width: 100%;
  height: 100%;

  padding: 0 8px;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  gap: 7px;

  &__icon {
    width: 24px;
    height: 24px;
  }

  &__text {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    gap: 3px;

    &__label {
      font-style: normal;
      font-weight: 700;
      font-size: 9px;
      line-height: 10px;
    }

    &__value {
      font-style: normal;
      font-weight: 400;
      font-size: 20px;
      line-height: 32px;
      color: var(--provider-color);
    }
  }

  @include Tablet--Large {
    gap: 24px;

    &__icon {
    width: 60px;
    height: 60px;
    }

    &__text {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;
      align-items: center;
      gap: 5px;

      &__label {
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
      }

      &__value {
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 40px;
      }
    }
  }

}
</style>
